import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/colors.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/materialdesignicons/mdi.min.css'
import App from './App';
import './plugins/i18n'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
